var baseStyle = {
  color: 'gray.400',
  transition: '100ms color ease-in-out',
  fontSize: 'xl',
  _hover: {
    color: 'gray.500'
  },
  _disabled: {
    color: 'gray.200',
    cursor: 'not-allowed'
  }
};
var CloseButton = {
  baseStyle: baseStyle
};
export { CloseButton as default };